<div class="pb-7 p-2 pt-2">
  <div class="pb-3">
    {{ 'CHANGE_MAIL_ADDRESS_TEXT' | translate }}
  </div>
  <div class="formgrid grid">
    <div class="field col-12">
      <app-verify-mail [(mailAddress)]="newMail" [showInputAlways]="true"
                       [baseUrl]="playerProfile ? baseUrlPlayerProfile : baseUrlDefault"
                       (onVerified)="mailConfirmed = true; changeMailAdress()"/>
    </div>
  </div>
</div>

<div class="dialog-footer flex">
  <div class="flex justify-content-end">
    <p-button type="submit" [label]="'CHANGE_MAIL_ADDRESS' | translate"
              styleClass="p-button-text" icon="pi pi-check"
              (onClick)="changeMailAdress()"
              [loading]="isSaving" [disabled]="isSaving || !(newMail) || !mailConfirmed"/>
    <p-button (onClick)="onCancelClicked()" [label]="'CANCEL' | translate" styleClass="p-button-text"
              icon="pi pi-times" [disabled]="isSaving"/>
  </div>
</div>
